import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { OldLegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';

@Injectable()
export class RoleService extends OldLegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/roles';
	}

	public getCombo(): Observable<any[]> {
		return this._restClientService.get(`${this.apiUrl}/combo`);
	}
}
